import { Routes } from '@angular/router';
import { authGuard, SPECTRUM_HELP_ROUTES } from 'common';

export const routes: Routes = [
    {
        path: 'validate',
        loadComponent: () => import('./validate/validate.component').then(m => m.ValidateComponent)
    },
    {
        path: 'login',
        loadComponent: () => import('common').then(m => m.SpectrumLoginComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/screens.component').then(m => m.ScreensComponent),
        children: [
            // The Help centre: this module's manual and Getting around Spectrum.
            ...SPECTRUM_HELP_ROUTES,
            { path: '', redirectTo: 'overview', pathMatch: 'full' },
            {
                path: 'overview',
                loadComponent: () => import('./screens/overview/overview.component').then(m => m.OverviewComponent)
            },
            {
                path: 'personal',
                loadComponent: () => import('./screens/personal-info/personal-info.component').then(m => m.PersonalInfoComponent)
            },
            {
                path: 'job',
                loadComponent: () => import('./screens/job-career/job-career.component').then(m => m.JobCareerComponent)
            },
            {
                path: 'leave',
                loadComponent: () => import('./screens/leave-attendance/leave-attendance.component').then(m => m.LeaveAttendanceComponent)
            },
            {
                path: 'salary',
                loadComponent: () => import('./screens/salary-bank/salary-bank.component').then(m => m.SalaryBankComponent)
            },
            {
                path: 'documents',
                loadComponent: () => import('./screens/documents/documents.component').then(m => m.DocumentsComponent)
            },
            {
                path: 'timetable',
                loadComponent: () => import('./screens/timetable/timetable.component').then(m => m.TimetableComponent)
            },
            {
                path: 'security',
                loadComponent: () => import('./screens/security/security.component').then(m => m.SecurityComponent)
            }
        ]
    },
    { path: '**', redirectTo: '' }
];
